module.exports = __webpack_public_path__ + "static/img/background-3.55d9ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-3.jpg
// module id = VMvl
// module chunks = 0